export default __webpack_public_path__ + "static/drawing-f906b91fb5be406a271779420dcee49b.png";